import { Grid, MenuItem, Typography, Pagination, PaginationItem, Select, useTheme, IconButton, Menu, Divider, ListItemIcon } from "@mui/material";
import { CSSProperties, useEffect, useState } from "react";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SortIcon from '@mui/icons-material/Sort';
import { Sort } from ".";
import Check from '@mui/icons-material/Check';
import { TableHeadRows } from "./TableHead";

interface SortOptions {
    sortFieldsData: {name: string; label: string}[];
    setSort: (th: TableHeadRows, i: number) => void;
    // setSortField: (field: string) => void;
    sort?: Sort;
    sortField?: string;
}

interface TablePaginationBarProps {
    totalItems: number;
    page: number;
    itemsPerPage?: number;
    setPage: (newPage: number) => void,
    onChangePageQuantity?: (pageQuantity: number) => void,
    setStartItemIndex: (index: number) => void,
    setFinishtemIndex: (index: number) => void,
    hiddenItemsPerPage?: boolean;
    style?: CSSProperties;
    // downloadData?: DownloadData;
    setDrawerFiltersOpen?: (open: boolean | undefined ) => void;
    drawerFiltersOpen?: boolean | undefined;
    oneRowPaginator?: boolean;
    sortOptions?: SortOptions
}

const TablePaginationBar = ({
    hiddenItemsPerPage,
    totalItems,
    itemsPerPage,
    page,
    setPage,
    onChangePageQuantity,
    setStartItemIndex,
    setFinishtemIndex,
    style,
    // downloadData,
    setDrawerFiltersOpen,
    drawerFiltersOpen,
    oneRowPaginator,
    sortOptions,
}: TablePaginationBarProps) => {

    const theme = useTheme();
    const [pageQuantity, setPageQuantity] = useState<number>(itemsPerPage || 10);
    const [minitem, setMinitem] = useState<number>(0);
    const [maxitem, setMaxitem] = useState<number>(0);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleOpenOrderMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleChangePageQuantity = (event: { target: { value: string } }) => {
        const pageNumber = event.target.value;
        if (pageQuantity === Number(pageNumber)) {
            return
        }
        setPageQuantity(Number(pageNumber));
        if (!onChangePageQuantity) {
            return
        }
        onChangePageQuantity(Number(pageNumber))
    };

    const handleChangePage = (event: any, pageNumber: number) => {
        setPage(Number(pageNumber));
    }

    useEffect(() => {
        if (itemsPerPage) {
            setPageQuantity(Number(itemsPerPage))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsPerPage])
    useEffect(() => {
        setStartItemIndex(minitem - 1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minitem])
    useEffect(() => {
        setFinishtemIndex(maxitem - 1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [maxitem])

    useEffect(() => {
        // if (page !== 1) {
        //     setPage(1)
        // }
        if (!onChangePageQuantity) {
            return
        }
        onChangePageQuantity(pageQuantity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (page < 1) {
            return
        }
        const minItem = ((page - 1) * pageQuantity) + 1;
        const maxItem = (page * pageQuantity);
        setMinitem(totalItems > 0 ? minItem : 0);
        setMaxitem(maxItem < totalItems ? maxItem : totalItems)
    }, [totalItems, pageQuantity, page])
    

    return (
        <Grid style={{...(style ? style: {}), lineHeight: 0, padding: ".5rem"}}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid 
                    container 
                    item xs={8} sm={oneRowPaginator ? hiddenItemsPerPage ? 8 : 6 : 3} md={oneRowPaginator ? 6 : 4} xl={oneRowPaginator ? 6 : 3}
                    style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }} // Agregamos flexWrap para que no se desborde
                >
                <Typography 
                    variant="subtitle1" 
                    color={theme.s10palette.S10Greygrey300} 
                    style={{ marginRight: '1rem',  }} // whiteSpace evita saltos innecesarios
                >
                    Resultados {minitem}-{maxitem} de {totalItems}
                </Typography>

                {drawerFiltersOpen !== undefined && setDrawerFiltersOpen && <IconButton
                    id="demo-positioned-button"
                    aria-haspopup="true"
                    onClick={() => setDrawerFiltersOpen(true)}
                    color="primary"
                    style={{ padding: 0 }}
                >
                    <FilterAltIcon />
                </IconButton>}
                {!!sortOptions?.sortFieldsData?.length &&
                    <div>
                    
                        <IconButton
                            id="basic-button"
                            aria-haspopup="true"
                            onClick={handleOpenOrderMenu}
                            color="primary"
                            style={{ padding: 0 }}
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <SortIcon />
                        </IconButton>

                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                            'aria-labelledby': 'basic-button',
                            }}
                        >   
                            <MenuItem >Elegir orden:</MenuItem>
                            <Divider />
                            {sortOptions?.sortFieldsData.map((f, i) => (
                                <MenuItem 
                                    key={i}
                                    onClick={() => {
                                        sortOptions.setSort({
                                            ...f,
                                            allowOrderAction: true,
                                            rowKeyName: f.name,
                                            label: f.label,
                                        }, 0)
                                        
                                        handleClose();
                                    }}
                                >
                                    {f.name === sortOptions.sortField && <ListItemIcon>
                                        <Check />
                                    </ListItemIcon>}
                                    {f.label}
                                    {f.name === sortOptions.sortField ? ` - ${sortOptions.sort}` : ''}
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                }
                </Grid>
                <Grid item xs={12} sm={6} md={4} xl={6} sx={{display: {xs: "none", sm: oneRowPaginator ? "none" : "block"}}}>
                    <Pagination 
                        sx={{
                            '& > .MuiPagination-ul': {
                            justifyContent: 'center',
                            },
                        }}
                        style={{
                            fontSize: "3rem"
                        }}
                        page={page}
                        onChange={handleChangePage}
                        count={Math.ceil(totalItems / pageQuantity)} 
                        size="small" 
                        renderItem={(item) => (
                            <PaginationItem
                                // slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                {...item}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={4} sm={oneRowPaginator ? 6 : 3} md={oneRowPaginator && !hiddenItemsPerPage ? 6 : 4} xl={oneRowPaginator ? 6 : 3}>
                    {!hiddenItemsPerPage && <Grid container justifyContent="flex-end" alignItems="center">
                        <Grid item>
                            <Typography variant="subtitle1" color={theme.s10palette.S10Greygrey300} marginRight=".5rem">
                                Cantidad: 
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Select
                                onChange={handleChangePageQuantity}
                                value={String(pageQuantity)}
                                style={{height: "2.5rem"}}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                {/* <MenuItem value={"2"}>2</MenuItem> */}
                                {/* <MenuItem value={"10"}>10</MenuItem> */}
                                <MenuItem value={"25"}>25</MenuItem>
                            </Select>
                        </Grid>
                    </Grid>}
                </Grid>
                <Grid item xs={12} sm={oneRowPaginator ? 12 : 6} md={oneRowPaginator ? 12 : 4} sx={{display: {xs: "block", sm: oneRowPaginator ? "block" : "none"}}}>
                    <Pagination 
                        sx={{
                            '& > .MuiPagination-ul': {
                            justifyContent: 'center',
                            },
                        }}
                        style={{
                            fontSize: "3rem"
                        }}
                        page={page}
                        onChange={handleChangePage}
                        count={Math.ceil(totalItems / pageQuantity)} 
                        size="small" 
                        renderItem={(item) => (
                            <PaginationItem
                                // slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                {...item}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Grid>
    )

}


export default TablePaginationBar;